module.exports = new __parcel__URL__("glacialencapsulation.579120fa.png").toString();